import { template as template_d512e56f020b4061b1c20b6662c2e95d } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { inputVal } from 'eflex/helpers';
import BsButton from 'eflex/components/bs-button';
export default template_d512e56f020b4061b1c20b6662c2e95d(`
<div class="link-input-wrapper input-group" ...attributes>
  <input
    class="form-control link-input"
    type="url"
    value={{@link}}
    disabled={{@disabled}}
    placeholder="https://"
    {{on "input" (inputVal @updateLink)}}
  />
  {{#if @previewLink}}
    <BsButton
      class="rounded rounded-start-0"
      @disabled={{@disabled}}
      @type="secondary"
      @onClick={{@previewLink}}
    >
      {{t "preview"}}
    </BsButton>
  {{/if}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
